module.exports = __webpack_public_path__ + "static/img/spread3-1.2f0fe90.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/life/spread3-1.jpg
// module id = QYfk
// module chunks = 1